import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';

import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

import moment from 'moment/moment';



import { ExpedienteProps } from '../interfaces/recepcion/ExpedienteInterface';
import { CitacionSentenciaProps } from '../interfaces/sentencia/CitacionSentenciaInterface';
import { TablePaginationActions } from '../helpers/TablePaginationActions';
import { usePages } from '../hooks/usePages';
import { BuscarCitacionSentencia } from '../connections/sentencia/CitacionSentenciaConnection';
import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';

interface params {
    open: boolean;
    handleClose: () => void;
    expediente: ExpedienteProps;
    tipoSentencia: number;
    obtenerCitacion: (data: CitacionSentenciaProps) => void;
}

export const DialogBuscarCitacionSentencia = ({ open, handleClose, expediente, tipoSentencia, obtenerCitacion }: params) => {

    const [rows, setRows] = useState<CitacionSentenciaProps[]>([]);

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages();

    const [loadingSearch, setLoadingSearch] = useState(false);

    const handleSeleccionar = (row: CitacionSentenciaProps) => {
        obtenerCitacion(row);
        handleClose();
    }

    useEffect(() => {

        async function Obtener() {

            setRows([]);
            setLoadingSearch(true);

            await BuscarCitacionSentencia({ idExpediente: expediente?.idExpediente ?? 0, idTipoSentencia: tipoSentencia }).then(response => {

                if (response) {

                    setTimeout(() => {

                        setRows(response);
                        setLoadingSearch(false);

                    }, 700);

                }

            });

        }

        if (open) {

            Obtener();

        }


    }, [open, expediente, tipoSentencia]);

    return (
        <>
            <Dialog open={open} maxWidth='md' fullWidth={true}>
                <DialogTitle>Citación de sentencia</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} style={{ marginTop: '1px' }}>

                        <Grid size={{ xs: 12, md: 12 }} >

                         <TableContainer sx={{ borderRadius: 3 }} component={Paper}>
                        
                            <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Número de <br /> Expediente</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Número de <br /> seguimiento</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Tipo de <br /> sentencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}> </TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%' }}> </TableCell>
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (rowsPerPage > 0
                                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : rows
                                            ).map((row) => (

                                                <TableRow key={row.idCitacionSentencia}>

                                                    <TableCell> {row.numeroExpediente ?? ''} </TableCell>

                                                    <TableCell>
                                                        {row.tipoAudiencia && <> GAU-{row.idAudiencia} </>}
                                                        {row.tipoAcuerdo && <> GAC-{row.idAcuerdo} </>}
                                                    </TableCell>

                                                    <TableCell> {row.fecha ? moment(row.fecha).format('DD-MM-YY HH:mm a') : ''} </TableCell>

                                                    <TableCell> {row.tipoSentencia ?? ''} </TableCell>

                                                    <TableCell>
                                                        {row.tipoAudiencia && <> Citada en <br /> <strong>{row.tipoAudiencia ?? ''}</strong> </>}
                                                        {row.tipoAcuerdo && <> Citada en <br /> <strong>{row.tipoAcuerdo ?? ''}</strong> </>}
                                                    </TableCell>

                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            endIcon={<PlaylistAddCheckIcon />}
                                                            size="small"
                                                            onClick={() => { handleSeleccionar(row); }}
                                                        >
                                                            Seleccionar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        }

                                        {
                                            rows.length === 0 &&
                                            (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={6}
                                                        align="center"
                                                        style={{ fontWeight: 'bold', fontSize: 15 }}
                                                    >
                                                        {
                                                            loadingSearch
                                                                ?
                                                                'Buscando ....'
                                                                :
                                                                'No se encontraron resultados'
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }


                                    </TableBody>

                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[]}
                                                colSpan={6}
                                                count={rows.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                ActionsComponent={TablePaginationActions}

                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                        return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />
                                        </TableRow>
                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                </DialogActions>

            </Dialog>


        </>
    )
}
